import {observer} from 'mobx-react-lite'
import React, {useEffect} from 'react'
import {Lang} from 'yougile-lang'
import {LoaderIcon} from '@components/common/base/loader-new'
import {useFileViewerStore} from '../file-viewer-store'
import {ImageView} from './image-view'
import {OtherView} from './other-view'
import {VideoView} from './video-view'

const FileViewStyle = {top: 72, right: 52, left: 52, bottom: 88}

export const FileView = observer(() => {
  const [state, store] = useFileViewerStore()

  const file = state.files.find(file => file.index === state.currentFileIndex)

  useEffect(() => {
    if (!file) {
      return
    }
    store.resetLoad()
    store.setCurrentFile(file)
    if (file.contentType === 'image') {
      store.loadImage(file.url)
    }
    if (file.contentType === 'video') {
      store.loadVideo(file)
    }
  }, [file])

  if (!file) {
    return <div>{Lang.msg.notFound}</div>
  }

  if (state.imageLoadError || state.videoLoadError) {
    return <OtherView />
  }

  return (
    <div className="absolute" style={FileViewStyle}>
      {state.imageLoad || state.videoLoad ? <LoaderIcon /> : <View />}
    </div>
  )
})

const View = observer(() => {
  const [state] = useFileViewerStore()

  switch (state.currentFile?.contentType) {
    case 'image':
      return <ImageView />
    case 'video':
      return <VideoView />
    default:
      return <OtherView />
  }
})
